// @ts-nocheck
import * as Yup from "yup";

const contractorCertificatesFormSchema = Yup.object().shape({
  OSHA_10: Yup.object()
    .shape({
      checked: Yup.boolean().required(),
      files: Yup.array().of(Yup.mixed()).max(3),
    })
    .required(),
  OSHA_30: Yup.object()
    .shape({
      checked: Yup.boolean().required(),
      files: Yup.array().of(Yup.mixed()).max(3),
    })
    .required(),
  CTS: Yup.object()
    .shape({
      checked: Yup.boolean().required(),
      files: Yup.array().of(Yup.mixed()).max(3),
    })
    .required(),
  ETC: Yup.object()
    .shape({
      checked: Yup.boolean().required(),
      files: Yup.array().of(Yup.mixed()).max(3),
    })
    .required(),
  Aerial_Scissor_Lifts: Yup.object()
    .shape({
      checked: Yup.boolean().required(),
      files: Yup.array().of(Yup.mixed()).max(3),
    })
    .required(),
  Forklift: Yup.object()
    .shape({
      checked: Yup.boolean().required(),
      files: Yup.array().of(Yup.mixed()).max(3),
    })
    .required(),
  Other: Yup.object().shape({
    checked: Yup.boolean().required(),
    value: Yup.array().of(
      Yup.object()
        .shape({
          checked: Yup.boolean().required(),
          otherCertificateName: Yup.string().required(),
          files: Yup.array().of(Yup.mixed()).max(3),
        })
        .required(),
    ),
    // .test(
    //   'should-be-comma-separated-values',
    //   'Please enter non-empty values separated by comma',
    //   function (code) {
    //     const splittedDimensions = this.parent?.value?.split?.(',')?.map(item => {
    //       return item?.trim();
    //     });

    //     if (splittedDimensions?.length === 0) {
    //       return false;
    //     } else {
    //       for (let i = 0; i < splittedDimensions?.length; i++) {
    //         if (!splittedDimensions?.[i]) {
    //           return false;
    //         }
    //       }

    //       return true;
    //     }
    //   }
    // )
    // .when("Other.checked", {
    //   is: true,
    //   then: Yup.string().required()
    // })
  }),
});

const contractorCertificatesInit = {
  OSHA_10: {
    checked: false,
    files: [],
  },
  OSHA_30: {
    checked: false,
    files: [],
  },
  CTS: {
    checked: false,
    files: [],
  },
  ETC: {
    checked: false,
    files: [],
  },
  Aerial_Scissor_Lifts: {
    checked: false,
    files: [],
  },
  Forklift: {
    checked: false,
    files: [],
  },
  Other: {
    checked: false,
    value: [],
  },
};
export {
  contractorCertificatesFormSchema,
  contractorCertificatesInit
}